export class ApiKey {
	id:number;
	name:string;

	public constructor(data:any){
		this.id = data.ID;
		this.name = data.Name;
	}
}